export function assetFolder (skill) {
  let s = String(skill || '').trim().toLowerCase()
  if (s === 'speaking' || s === 'speak' || s === '口语') return 'speaking'
  if (s === 'reading' || s === '阅读') return 'reading'
  if (s === 'writing' || s === '写作') return 'writing'
  if (s === 'listening' || s === '听力' || s === 'comp') return 'listening'
  return s || 'listening'
}

export function assetUrl (path, skill) {
  let raw = String(path || '').trim()
  if (!raw || raw.toLowerCase() === 'none') return ''
  if (/^https?:\/\//i.test(raw)) return raw
  let file = raw.replace(/\\/g, '/').split('/').pop()
  if (!file) return ''
  return 'https://file.kouyujie.cn/' + assetFolder(skill) + '/' + file
}

export function assetKind (url) {
  let file = String(url || '').split('?')[0].toLowerCase()
  if (/\.(png|jpe?g|gif|webp|bmp|svg)$/.test(file)) return 'image'
  if (/\.(mp3|wav|m4a|aac|ogg|flac)$/.test(file)) return 'audio'
  if (/\.(mp4|mov|webm|m4v)$/.test(file)) return 'video'
  return ''
}



// WEBPACK FOOTER //
// ./src/components/mex/mex-asset.js